import { render, staticRenderFns } from "./ProductInvoiceReport.vue?vue&type=template&id=2df94602&"
import script from "./ProductInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./ProductInvoiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports